import React from "react";
import { Box, SvgIcon, Typography } from "@mui/material";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./styles.css";

// Import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import PartnerCard from "./PartnerCard"; // Import PartnerCard
import TourObjects from "./ToursObjects"; // Assuming TourObjects has the necessary data
import { useIsMobile } from "../../../Hooks/useMedia";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

export default function Partners() {
   const partners = ["KLOOK", "Booking.com", "BuzzFeed"];
   const mobile = useIsMobile();
   return (
      <>
         <Swiper
            breakpoints={{
               300: {
                  slidesPerView: 1.4,
                  spaceBetween: 8,
                  centeredSlides: true,
               },
               410: {
                  slidesPerView: 1.7,
                  spaceBetween: 8,
                  centeredSlides: true,
               },
               600: {
                  slidesPerView: 2.5,
                  spaceBetween: 8,
                  centeredSlides: true,
               },
               768: {
                  slidesPerView: 3,
                  spaceBetween: 15,
                  centeredSlides: true,
               },
               1024: {
                  slidesPerView: 3,
                  spaceBetween: 15,
               },
            }}
            slidesPerView={1.5}
            spaceBetween={10}
            autoplay={{
               delay: 1750,
               disableOnInteraction: false,
            }}
            // navigation={{
            //    nextEl: ".swiper-button-next",
            //    prevEl: ".swiper-button-prev",
            // }}
            modules={[Navigation]}
            loop={true}
            style={{
               //    marginTop: mobile ? -95 : -35,
               paddingLeft: "0px",
            }}
         >
            {partners.map((partner, index) => (
               <SwiperSlide key={index}>
                  <PartnerCard title={partner} /> {/* Pass title to PartnerCard */}
               </SwiperSlide>
            ))}
         </Swiper>
      </>
   );
}
